import { Injectable } from '@angular/core';
import { SimuladorGoApi } from '@gestor-web/@core/api/go';
import { Exportacao } from '@gestor-web/@core/api/ords/model';
import { Page } from '@gestor-web/app/shared/components';
import { map } from 'rxjs/operators';

@Injectable()
export class ContasRepetidasService {
  constructor(private simuladorGoApi: SimuladorGoApi) {}

  getDataGoApi(
    regans: string,
    competenciaInicial: string,
    competenciaFinal: string,
    condicao: string,
    data_realizacao: string,
    pageData: Page,
  ) {
    return this.simuladorGoApi
      .fetchContasRepetidas({
        regans,
        condicao,
        data_realizacao,
        competencia: competenciaInicial,
        competencia_final: competenciaFinal,
        page: pageData.page,
        size: pageData.size,
      })
      .pipe(
        map(data => ({
          items: data.items ?? [],
          total: data.total ?? 0,
        })),
      );
  }

  requestExportacao(regans: string, params: Exportacao) {
    return this.simuladorGoApi.requestExportacaoContasRepetidas(regans, params);
  }

  getUltimoProcessamento(regans: string) {
    return this.simuladorGoApi.fetchContasRepetidasUltimoProcessamento({ regans });
  }
}
